<script setup lang="ts">
// UAE Dirham currency sign — the official "D" crossed by two bars, traced
// from the design asset. The viewBox is cropped to the glyph (no padding) so
// its bottom edge sits on the text baseline. Painted in currentColor so the
// caller tints it with CSS `color`. Size it via `CurrencySymbol`, which
// scales it to the surrounding font size.
defineOptions({ inheritAttrs: false })
</script>

<template>
  <svg
    viewBox="0 10.2 35 30.8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    v-bind="$attrs"
  >
    <path
      d="M4.48 41V10.2H14.82C18.3987 10.2 21.3613 10.8307 23.708 12.092C26.0547 13.3533 27.7853 15.1427 28.9 17.46C30.044 19.748 30.616 22.476 30.616 25.644C30.616 28.7533 30.044 31.4667 28.9 33.784C27.7853 36.072 26.0547 37.8467 23.708 39.108C21.3613 40.3693 18.3987 41 14.82 41H4.48ZM9.76 36.512H14.556C17.2253 36.512 19.3373 36.0867 20.892 35.236C22.4467 34.356 23.5467 33.1093 24.192 31.496C24.8667 29.8533 25.204 27.9027 25.204 25.644C25.204 23.356 24.8667 21.4053 24.192 19.792C23.5467 18.1493 22.4467 16.888 20.892 16.008C19.3373 15.0987 17.2253 14.644 14.556 14.644H9.76V36.512Z"
      fill="currentColor"
    />
    <path
      d="M1.5 30H33.5M1.5 22H33.5"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
    />
  </svg>
</template>
